package horcrux.frontend.common.views.collections

import horcrux.common.api.dtos.types.CollectionID
import horcrux.common.utils.EnumCompanion
import horcrux.common.utils.StringEnum
import horcrux.frontend.common.get
import horcrux.frontend.common.set
import horcrux.frontend.common.close
import horcrux.frontend.common.extensions.marginVertical
import horcrux.frontend.common.open
import mui.icons.material.ArrowDropDown
import mui.material.Button
import mui.material.ButtonGroup
import mui.material.ButtonGroupVariant
import mui.material.Menu
import mui.material.MenuItem
import mui.material.Size
import mui.system.sx
import react.FC
import react.Props
import react.dom.aria.AriaHasPopup
import react.dom.aria.ariaControls
import react.dom.aria.ariaExpanded
import react.dom.aria.ariaHasPopup
import react.dom.aria.ariaLabel
import react.dom.events.MouseEventHandler
import react.useState
import web.cssom.pt
import web.dom.Element
import web.html.HTMLButtonElement
import web.svg.SVGSVGElement

external interface ImportButtonProps : Props {
    var currentCollectionIDMaybe: CollectionID?
    var onClick: (ImportButtonLabel) -> MouseEventHandler<HTMLButtonElement>
}

enum class ImportButtonLabel(override val stringValue: String) : StringEnum {
    CREATE_COLLECTION_AND_IMPORT("Create Collection From Document"),
    IMPORT("Add Documents to Collection");

    fun isDisabled(collectionIDMaybe: CollectionID?): Boolean =
        when (this) {
            IMPORT -> collectionIDMaybe == null
            CREATE_COLLECTION_AND_IMPORT -> false
        }

    companion object : EnumCompanion<ImportButtonLabel> {
        override val valuesList: List<ImportButtonLabel>
            get() = listOf(IMPORT, CREATE_COLLECTION_AND_IMPORT)

        fun get(currentCollectionIDMaybe: CollectionID?): ImportButtonLabel =
            currentCollectionIDMaybe?.let {
                IMPORT
            } ?: run {
                CREATE_COLLECTION_AND_IMPORT
            }
    }
}

val ImportButton = FC<ImportButtonProps> { props ->
    val anchorElementState = useState<Element?>(null)
    val currentLabel = useState(ImportButtonLabel.get(props.currentCollectionIDMaybe))
    val isMenuOpenState = useState(false)
    val isMenuOpen = isMenuOpenState.get()

    fun openMenu(target: SVGSVGElement) {
        anchorElementState.set(target)
        isMenuOpenState.open()
    }

    fun closeMenu() {
        anchorElementState.set(null)
        isMenuOpenState.close()
    }

    ButtonGroup {
        this.variant = ButtonGroupVariant.contained
        this.ariaLabel = "show-import-documents-dialog"
        this.sx {
            this.marginVertical = 5.pt
        }
        Button {
            +currentLabel.get().stringValue
            this.onClick = { props.onClick(currentLabel.get())(it) }
        }
        Button {
            this.ariaControls = "import-documents-menu"
            this.ariaExpanded = isMenuOpen
            this.ariaHasPopup = AriaHasPopup.menu
            this.size = Size.small
            ArrowDropDown {
                this.onClick = { openMenu(it.currentTarget) }
            }
        }
    }
    Menu {
        this.anchorEl = anchorElementState.get()?.let { { _ -> it } }
        this.open = isMenuOpen
        this.onClose = { closeMenu() }
        for (label in ImportButtonLabel.valuesList) {
            MenuItem {
                +label.stringValue
                this.disabled = label.isDisabled(props.currentCollectionIDMaybe)
                this.onClick = {
                    currentLabel.set(label)
                    closeMenu()
                }
            }
        }
    }
}
